const layout = () => import("../../external/layout.vue");
const loginRegister = () => import("./loginRegister.vue");

const loginRegisterRoutes = {
  component: layout,
  children: [
    {
      path: "/loginRegister",
      name: "loginRegister",
      component: loginRegister,
    },
  ],
};

export default loginRegisterRoutes;